<div class="container-fluid full-width">
  <div class="top-cont">
    <div class="business-services__container_pay">
      <div class="payment-services__inner-div_bus cus-bnd">
        <ul class="breadcrumb">
          <li class="breadcrumb-item active underlined-breadcrumb" aria-current="page">
            <a class="bread-hover-change" href="/business-services/">
              Business
              Services
            </a>
          </li>
          <li><a class="unselected-breadcrumb">Payment Services</a></li>
        </ul>
        <span>
          <h3 class="payment-services__inner-div--heading_bus">Payment Services</h3><br>
          <hr class="payment-services__hr_bus">
        </span>
        <div class="payment-services__inner-div--content bus_wor0">
          Secure, affordable payment solutions for businesses.

        </div>

        <div class="hero-panel-button bus_btn">
          <a href="/about/contact-us/" class="get-secret-btn" style="margin-bottom: 0px!important;" tabindex="-1">
            Contact Us
            <img class="image-left" src="../../../../assets/redesignImages/button-menu.png"></a>
        </div>
      </div>
      <img class="business-services__image_bus" alt="Business-services-img"
        src="../../../../assets/redesignImages/payment.png" width="535" height="332">
    </div>

    <img class="media-margin-value" src="../../../../assets/redesignImages/Vector.png">
  </div>

  <!-- UL container -->

  <h2 class="simplified-shipping__inner-container">
    Discover a Better Way to Get Paid
  </h2>
  <hr class="simplified-shipping__hr">



  <div class="row g-0 cont-bg1">
    <div class="col ic-grp ">
      <div class="text-center  img-tag">
        <img class="rounded mx-auto d-block ico-img" src="../../../../assets/redesignImages/chart_data.png" />
      </div>

      <div class="wrapper">

        <p class="tit-0 maj">Grow Confidently</p>
        <p class="tit-0 sml">Add value to your customers and keep your bottom line protected.
        </p>
      </div>

    </div>
    <div class="col ic-grp">
      <div class="text-center img-tag">
        <img class="ico-img1 rounded mx-auto d-block" src="../../../../assets/redesignImages/add_card.png" />
      </div>
      <div class="wrapper">
        <p class="tit-0 maj ">Expand Payment Options</p>
        <p class="tit-0 sml">Be ready for all the ways your customers want to pay.
        </p>
      </div>
    </div>
    <div class="col ic-grp ">
      <div class="text-center img-tag">
        <img class="ico-img2 rounded mx-auto d-block" src="../../../../assets/redesignImages/payments.png" />
      </div>
      <div class="wrapper">
        <p class="tit-0 maj">Protect Cash Flow</p>
        <p class="tit-0 sml">Meet industry security standards without added costs.</p>
      </div>
    </div>
  </div>

  <!-- Insuring the Uninsurable Container -->

  <div class="card-bus card-container1">

    <div class="card fl0">

      <div class="card-header BsHead">
        <h2 class="sub-title">Merchant Services</h2>
      </div>
      <div class="card-img BsImage ">
        <img class="img-fluid" src="../../../../assets/redesignImages/paymentServicesNewImgScreenshot.png" />

      </div>
      <div class="card-body BsBody crB02">
        <div class="card-body-content">
          <p class="sub-cont0">Our partnership with Chase offers a simplified payment experience.</p>

          <div class="hero-panel-button home-btn01">
            <a class="get-secret-btn home-btn02" tabindex="-1"
              href="/business-services/payment-services/merchant-services/">Learn More <img class="btn-mn0"
                src="../../../../assets/redesignImages/button-menu.png"></a>
          </div>

        </div>
      </div>
    </div>

  </div>

  <div class="card-container">

    <div class="card fl0">

      <div class="card-header crHead">
        <h2 class="sub-title">C.O.D. Payments</h2>
      </div>
      <div class="card-img imgbn0">
        <img class="img-fluid" src="../../../../assets/redesignImages/img_p.png" />

      </div>
      <div class="card-body crB01">
        <div class="card-body-content">
          <p class="sub-cont0">Enjoy the flexibility to control the timing of individual check deposits. </p>

          <div class="home-btn01 ">
            <a href="/business-services/payment-services/cod/" class="get-secret-btn width-new home-btn02"
              tabindex="-1">Explore How <img class="btn-mn0 "
                src="../../../../assets/redesignImages/button-menu.png"></a>
          </div>


        </div>
      </div>
    </div>

  </div>
  <!-- Get Connected Container -->

  <div class="card" id="contact-card">
    <div class=" get-conn-container-body card-body">
      <h5 class=" card-title">Ask An Expert
      </h5>

      <p class="card-text sub-para">Questions? We’ll connect you to people with the answers.</p>
      <a href="/about/contact-us" style="color:#121212; text-decoration: none;">
        <button class="trade-credit__button">
          Contact Us
          <img class="btn-not0" src="../../../../assets/redesignImages/sli-buttonArrow.png">
        </button>
      </a>
    </div>
    <img class="flexible-coverage-bg-image" alt="Business-services-img"
      src="../../../../assets/redesignImages/Gradient.png" width="350" height="200">
  </div>

  
  <br class="media-br-display">
  <br class="media-br-display">
</div>

